// --- External tools
import axios from 'axios';

// --- Logic
import { commonConfiguration } from 'io/API';
import { getCookie } from 'utils/cookies';

const postPasswordResetConfirm = (token, email, password1, password2, contextConfiguration) => {
	const csrfToken = getCookie('csrftoken');

	// Match Django form behavior: POST to same URL with query params and URL-encoded body
	const url = `/reset-password?token=${encodeURIComponent(token)}&email=${encodeURIComponent(email)}`;

	const form = new URLSearchParams();
	if (csrfToken) 
		form.append('csrfmiddlewaretoken', csrfToken);
	form.append('token', token);
	form.append('email', email);
	form.append('password1', password1);
	form.append('password2', password2);

	return axios.post(
		url,
		form,
		{
			...commonConfiguration,
			...contextConfiguration,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'X-Requested-With': 'XMLHttpRequest',
				...(csrfToken ? { 'X-CSRFToken': csrfToken } : {}),
			},
		}
	);
};

export default postPasswordResetConfirm;
